import { IAbExperiment } from '../../types/abUseExperiments';

const initialState: IAbExperiment[] = [];

export function abUseExperimentsReducer(state = initialState): IAbExperiment[] {
  return state;
}
